export default "__VITE_ASSET__bFxTRdgu__"